import React, { useEffect, useState } from 'react';
import {
  Box,
  Checkbox,
  IconButton,
  Typography,
  Modal,
  Button,
} from '@mui/material';

import { IFormData, IChecklist, IDocumentInput } from '@homeporter/types';

import LinkIcon from '@mui/icons-material/Link';
import { useChecklistStyles } from './styles';

interface _function {
  (sid: string): void;
}
interface ChecklistDataProps {
  checklistCard: IChecklist;
  setSaveEnabled: (enabled: boolean) => void;
  highlightedSids: string[];
  setHighlightedSids: (_: string[]) => void;
  setHighlightSentence: (_: _function | undefined) => void;
}

const ChecklistBlock = ({
  checklistCard,
  setSaveEnabled,
  highlightedSids,
  setHighlightedSids,
  setHighlightSentence,
}: ChecklistDataProps) => {
  const styles = useChecklistStyles();
  const [checkedItems, setCheckedItems] = useState<string[]>([]);
  const [data, setData] = useState<IFormData[]>([]);

  useEffect(() => {
    const data: IFormData[] = checklistCard?.data || [];
    setData(data);

    if (!data || data.length === 0) {
      setCheckedItems([]);
      return;
    }

    const checked: string[] = [];

    try {
      Array.isArray(data) &&
        data.forEach((sectionEntry) => {
          sectionEntry.children.forEach((child) => {
            child.items.forEach((item: IDocumentInput) => {
              checked.push(
                item.uir !== undefined
                  ? item.uir === '1'
                    ? 'u'
                    : ''
                  : item.air === '1'
                    ? 'a'
                    : '',
              );
            });
          });
        });
    } catch (error) {}

    setCheckedItems(checked);
  }, [checklistCard]);

  const [modalOpen, setModalOpen] = useState(false);

  const handleCheckItem = (item: IDocumentInput) => {
    console.log(':::::checkedItems[item.idx]:', checkedItems[item.idx]);
    console.log(':::::item.uir:', item.uir);

    if (checklistCard.validated) {
      setModalOpen(true);
      return;
    }

    checkedItems[item.idx] = checkedItems[item.idx]
      ? ''
      : item.asids
        ? 'a'
        : 'u';

    item.usids =
      checkedItems[item.idx] === 'a' || !checkedItems[item.idx]
        ? undefined
        : ['-1'];
    item.uir = checkedItems[item.idx] === 'u' ? '1' : undefined;
    item.air = checkedItems[item.idx] === 'a' ? '1' : undefined;

    setCheckedItems([...checkedItems]);
    setSaveEnabled(true);
    setHighlightedSids([]);

    console.log(':::::checkedItems:', checkedItems);
    console.log(':::::handleCheckItem:', item);
  };

  return (
    <>
      {modalOpen && (
        <Modal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          aria-labelledby="validation-modal"
          aria-describedby="validation-modal-description">
          <Box sx={styles.modal}>
            <Typography id="validation-modal" variant="h6" component="h2">
              Cannot Edit Validated Checklist
            </Typography>
            <Typography id="validation-modal-description" sx={{ mt: 2 }}>
              This checklist is validated and cannot be edited.
            </Typography>
            <Button
              onClick={() => setModalOpen(false)}
              sx={{ mt: 2 }}
              variant="contained">
              OK
            </Button>
          </Box>
        </Modal>
      )}
      {Array.isArray(data) &&
        data.map((sectionEntry, sectionIndex) => (
          <Box
            sx={{ paddingLeft: '1rem' }}
            key={sectionEntry?.title || sectionIndex}>
            <h3 style={{ margin: '.5rem 0' }}>{sectionEntry?.title}</h3>
            {sectionEntry?.children?.map((child, childIndex) => (
              <Box
                sx={{ paddingLeft: '1rem' }}
                key={child.subtitle || childIndex}>
                <h4 style={{ margin: '.5rem 0' }}>{child.subtitle}</h4>
                {child.items.map((item: IDocumentInput, idx: number) => (
                  <Box sx={styles.checklistItem} key={item.idx ?? idx}>
                    <Checkbox
                      id={`idx_${item.idx}`}
                      checked={checkedItems[item.idx] !== ''}
                      onChange={(e) => {
                        e.stopPropagation();
                        handleCheckItem(item);
                      }}
                      title={`${item.idx} ${item.asids}`}
                      onClick={(e) => e.stopPropagation()}
                      sx={{
                        ...styles.checkBox,
                        color:
                          checkedItems[item.idx] === '' && !!item.asids
                            ? 'orange'
                            : '#aaa',
                        '&.Mui-checked': {
                          color:
                            checkedItems[item.idx] === 'u'
                              ? 'orange'
                              : '#5bbfc2', // #e8f7f8, #b7e4e6, #8fd2d4, #5bbfc2
                        },
                      }}
                    />
                    <Box sx={styles.checklistItemTextContainer}>
                      <Typography sx={styles.checklistItemText}>
                        {item.label || item.text}
                      </Typography>
                      {(item.usids || item.asids) && (
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            console.log(':::::handleCheckItem:', item);
                            if (item.uir === '1') {
                              const f = (sid: string) => {
                                if (item.usids) {
                                  if (item.usids.includes(sid)) {
                                    console.log(
                                      `remove ${sid} from ${item.usids}`,
                                    );
                                    item.usids = item.usids.filter(
                                      (s) => s !== sid,
                                    );
                                  } else {
                                    console.log(
                                      `add ${sid} from ${item.usids}`,
                                    );
                                    item.usids.push(sid);
                                  }
                                  item.usids = [...item.usids];
                                  setHighlightedSids(item.usids);
                                  setSaveEnabled(true);
                                  console.log(item.usids);
                                }
                              };

                              setHighlightSentence(() => f);
                            }
                            setHighlightedSids(
                              highlightedSids === item.asids ||
                                highlightedSids === item.usids
                                ? []
                                : item.usids || item.asids || [],
                            );
                          }}
                          sx={{
                            ...styles.iconButton,
                            backgroundColor:
                              highlightedSids === item.usids
                                ? '#ffdab3'
                                : highlightedSids === item.asids
                                  ? '#e8f7f8'
                                  : 'inherit', //#FFFACD
                          }}>
                          <LinkIcon fontSize="small" />
                        </IconButton>
                      )}
                    </Box>
                  </Box>
                ))}
              </Box>
            ))}
          </Box>
        ))}
    </>
  );
};

export default ChecklistBlock;
